
import { Component, Vue, Watch } from 'vue-property-decorator'
import GoodsSwipe from '@/components/GoodsSwipe/index.vue'
import StepperTemp from '@/components/StepperTemp/index.vue'
import CountDown from '@/views/industryMall/shop/template/countDown.vue'
import {
  MinConfigDto,
  PickupDetailDto,
  getCyStoreGoodsDtl,
  ShopGoodsInfoDto,
  getCyGoodsSpecificationList,
  getStoreDtl,
  isGoodsValid,
  getMinDeliverGoods,
  getSendGoodsTime,
  getSelfPickupPoint,
  getPickupGoodsTime,
  addStoreShoppingCart,
  getStoreShoppingCartCount,
  getActivityGoodsList,
  batchAddStoreShoppingCart
} from '@/api/industryMall'
import { StoreDtlOTD, PackageListDto } from '@/views/industryMall/shop/shop'
import PackageSelector from '@/views/industryMall/components/PackageSelector/index.vue'
import PackageSelector1 from '@/views/industryMall/components/PackageSelector/indexCopy1.vue'
import { Getter, Action } from 'vuex-class'
import { handleFill, imagePreview, moneyFormat } from '@/utils/util'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import store from '@/store'
import dayjs from 'dayjs'
import newPackageSelector from './template/packageSelector.vue'
import math from '@/core/math'

const ways = {
  1: '第三方物流',
  2: '买家自提',
  3: '商家配送'
}
@Component({
  name: 'GoodsDetail',
  components: {
    GoodsSwipe,
    PackageSelector,
    PackageSelector1,
    CountDown,
    StepperTemp,
    newPackageSelector
  },
  filters: {
    filterCity(val: { countryName: string }[]) {
      if(!val.length) {
        return '无'
      }
      if (!val[0].countryName) {
        return '无'
      }
      return val.map((item) => item.countryName).join()
    },
    filterWay(val: string) {
      return ways[val] || '无'
    }
  }
})
export default class GoodsDetail extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter info!: LoginReturnDataDto
  @Action setPreOrderParams!: (val) => void

  handleFill = handleFill
  imagePreview = imagePreview

  isFavorite = false
  params = {
    storeId: '',
    goodsId: ''
  }
  detailInfo: ShopGoodsInfoDto = {}
  defaultDetailInfo: ShopGoodsInfoDto = {} // 默认的后端接口返回的数据，用于取消掉规格之后的数据重置
  packageList: PackageListDto[] = []
  onlyOnePackage = false // 判断是否只有一个套餐
  packageName = '' // 套餐名称
  sellDesc = '' // 销售方式
  // packageWeight = '' // 套餐重量
  selectValueList: string[] = [] // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格
  buycarLength = 0

  packageId = '' // 规格编号

  storeInfo: StoreDtlOTD = {} // 店铺

  textShow = false // 文字显示
  storeTextShow = false // 店铺文字显示
  activeIndex = 0 // 单规格-套餐选中
  showTips = false
  warnInfo = { // 警告配置
    storeName: '',
    storeId: '',
    needMoney: 0 // 还差多少钱
  }
  minConfig!: MinConfigDto // 送货上门 - 最小金额配置
  sendTimeConfig = {} // 送货上门 - 配送时间设置
  pickupConfig!: PickupDetailDto // 站点自提 - 是否开启及详情配置
  pickupTimeConfig = {} // 站点自提 - 自提时间配置
  activityData: any = {}
  orderQuantity = 0 // 单规格数量选中

  get marketPrice() {
    if(this.packageList[this.activeIndex] && !this.detailInfo.isMultiSpec) {
      // return this.packageList[this.activeIndex].marketPrice
      if (this.isActivity) { // 活动中商品-商品详情取值
        return this.detailInfo.finalPrice
      }
      return this.packageList[this.activeIndex].finalPrice
    }
    return this.detailInfo.goodsPriceMin
  }

  get totalPrices() {
    let price = 0
    let list = this.packageList[0].levelPriceList
    // this.packageList[0].levelPriceList.
    // prices = this.orderQuantity + 100
      if (list && list.length) {
      const fuHe = list.find(element => this.orderQuantity >= element.minAmount && (this.orderQuantity < element.maxAmount || !element.maxAmount))
      if (fuHe) {
        price = fuHe.finalPrice
      } else {
        console.log(list, '0000000');
        price = this.packageList[0].marketPrice
      }
    } else {
      price = this.packageList[0].marketPrice
    }
    return moneyFormat(this.orderQuantity * price) // 当前区间价格
  }

  get countDownTime () {
    if (!this.activityData.activityId) return ''
    const dateString = dayjs().format('YYYY/MM/DD')
    if (this.activityData.timeType === 1) return dayjs(this.activityData.closeTime).format('YYYY/MM/DD HH:mm:ss')
    else return `${dateString} ${this.activityData.endTime}`
  }

  // 是否阶梯定价
  get isLadderPrice () {
    if (this.packageList[this.activeIndex].levelPriceList && this.packageList[this.activeIndex].levelPriceList.length) {
      return true
    }
    return false
  }

  isActivity() {
    return (this.detailInfo.isAddTag === 0 || this.detailInfo.isAddTag === 1)
  }

  created() {
    this.getDeliveryConfig()
    this.params.goodsId = this.$route.query.goodsId as string
    this.params.storeId = this.$route.query.storeId as string
    this.getInfo()
    this.getPackageList()
    this.getStoreDtl()
    this.getStoreShoppingCartCount()
  }

  getDeliveryConfig () {
    const storeId = this.$route.query.storeId as string
    // 获取送货上门最低金额配置
    getMinDeliverGoods({ storeId }).then((res: any) => {
      this.minConfig = { storeId, ...res.data } as MinConfigDto
    })
    // 获取各店铺送货上门时间设置
    getSendGoodsTime({ storeId }).then((res: any) => {
      this.sendTimeConfig = { storeId, ...res.data }
    })
    // 获取是否开启站点自提配置
    getSelfPickupPoint({ storeId, buyCompanyId: this.companyId }).then((res: any) => {
      this.pickupConfig = { storeId, ...res.data }  as PickupDetailDto
    })
    // 获取各店铺自提时间设置
    getPickupGoodsTime({ storeId }).then((res: any) => {
      this.pickupTimeConfig = { storeId, ...res.data }
    })
  }

  /**
   * 处理销售方式
   */
  handleSellDesc(info:ShopGoodsInfoDto) {
    return false
  }

  // 套餐数量
  changeQuantity() {
  }

  // 切换规格
  chooseSinglePackage(index: number) {
    this.orderQuantity = 1
    this.activeIndex = index
  }

  /**
   * 获取购物车数量
   */
  getStoreShoppingCartCount() {
    getStoreShoppingCartCount({partnerCompanyId: this.info.partnerCompanyId}).then(res => {
      this.buycarLength = res.data.count
    })
  }

  /**
   * @description 获取产业商城信息
   * @param companyId
   */
  getStoreDtl() {
    getStoreDtl({ companyId: this.params.storeId }).then((res) => {
      this.storeInfo = res.data
    })
  }

  getActivityInfo (activityId: string) {
    // 获取活动信息
    activityId && getActivityGoodsList({ activityId }).then(res => {
      this.activityData = res.data[0] || {}
    })
  }

  /* 获取商品详细信息 */
  getInfo() {
    getCyStoreGoodsDtl(this.params).then((res) => {
      this.detailInfo = res.data || {}
      console.log('this.detailInfo-------------------------', this.detailInfo)
      this.defaultDetailInfo = JSON.parse(JSON.stringify(this.detailInfo))
      this.getActivityInfo(this.detailInfo.activityId)
    })
  }

  getSelectPackageInfo(info: PackageListDto, selectValueList: string[]) {
    // console.log('info', info, selectValueList)
    // if (selectValueList && selectValueList.length > 0) {
    //   this.onlyOnePackage = true
    //   this.packageName = info.packageNameDesc
    //   // this.detailInfo.goodsPrice = info.marketPrice
    //   this.detailInfo.goodsPrice = info.finalPrice
    // } else {
    //   this.detailInfo.goodsPrice = this.defaultDetailInfo.goodsPrice
    //   if (this.defaultDetailInfo.isMultiSpec) {
    //     this.onlyOnePackage = false
    //     this.packageName = ''
    //   } else {
    //     this.onlyOnePackage = true
    //     this.packageName =
    //       this.packageList[0] && this.packageList[0].packageNameDesc
    //   }
    // }
    // if(info.sellUnit) {
    //   this.sellDesc = info.sellUnit + info.sellUnitWay
    // }
    // this.selectValueList = selectValueList
    // this.getStoreShoppingCartCount()
  }

  // 计算套餐价格
  getSellPrice(marketPrice, sellUnit) {
    let price = Number(marketPrice)
    if (price) {
      return (price / sellUnit).toFixed(2)
    }
  }

  /**
   * 获取套餐列表
   * 获取商品规格
   * */
  getPackageList() {
    getCyGoodsSpecificationList({ ...this.params }).then((res) => {
      this.packageList = res.data.packageList || []
      // 单规格
      if (this.packageList.length === 1) {
        this.orderQuantity = this.packageList[0].sellUnit
      }
      // this.packageList = res.data.packageList.map((item) => {
      //   // item.sellPrice = this.getSellPrice(item.marketPrice, item.sellUnit)
      //   item.sellPrice = this.getSellPrice(item.finalPrice, item.sellUnit)
      //   return { ...item }
      // })
      // if (this.packageList) {
      //   this.onlyOnePackage = this.packageList.length <= 1
      //   if (this.onlyOnePackage) {
      //     this.packageName =
      //       this.packageList[0] && this.packageList[0].packageNameDesc
      //     this.packageId = this.packageList[0] && this.packageList[0].packageId
      //     if (res.data.goodsSpecificationList.length) {
      //       // 只有一个规格时，打开规格表让第一个多规格属性选中
      //       this.selectValueList = res.data.goodsSpecificationList.map(
      //         (item) => {
      //           return item.specValueList[0].attrValueCode
      //         }
      //       )
      //     }
      //   }
      // }
    })
  }

  // 加入购物车
  batchAddStoreShoppingCart() {
    const param = {
      partnerCompanyId: this.info.partnerCompanyId,
      storeId: this.detailInfo.storeId,
      // goodsId: this.detailInfo.goodsId,
      // packageId: this.packageList[this.activeIndex].packageId,
      // orderQuantity: this.orderQuantity
      goodsInfoList: [
        {
          goodsId: this.detailInfo.goodsId,
          packageId: this.packageList[0].packageId,
          orderQuantity: this.orderQuantity
        }
      ]
    }
    batchAddStoreShoppingCart(param).then((res) => {
      if (res.code === '000000') {
        console.dir(document.querySelector('.add-shop'))
        console.log(document.querySelector('.shopBuyBtn'))
        this.$shopCarAnimation.show(document.querySelector('.add-shop'), '.shopBuyBtn')
        // this.$toast.success({
        //   message: '已添加到购物车中',
        //   duration: 1000
        // })
        store.dispatch('getShopCarNum', this.info.partnerCompanyId)
      } else if (res.code === '000002') {
        const data = res.data
        /* rejectType
            * NonOrderable:当前商品不可订货
            InvalidGoods：商品状态不为上架
            InvalidPackage：套餐状态不为上架
            * */
        if (data.rejectType === 'InvalidPackage') {
          this.$dialog.alert({
            message: '商品规格不存在，请重新选择'
          })
        } else if (
          data.rejectType === 'NonOrderable' ||
          data.rejectType === 'InvalidGoods'
        ) {
          this.$dialog.alert({
            message: '商品过期不存在'
          })
        }
      }
    })
  }

  // 立即下单
  placeOrder(params: any = {}) {
    const { minConfig, sendTimeConfig, pickupConfig, pickupTimeConfig } = this
    const totalMoney = params.packageId ? (params.orderQuantity * params.price) : this.packageList[this.activeIndex].finalPrice * this.orderQuantity
    let distributionWay = 1
    // 如果开启送货上门最低金额设置且不满足最低金额 // &&  未开启上门自提
    if (minConfig.minDeliverGoodsStatus === 1 && totalMoney < minConfig.minDeliverGoodsMoney && pickupConfig.pickupStatus !== '1') {
      this.warnInfo.storeId = this.detailInfo.storeId
      this.warnInfo.storeName = this.storeInfo.companyName
      this.warnInfo.needMoney = Number(math.mathSubtract(this.minConfig.minDeliverGoodsMoney, totalMoney))
      this.showTips = true
      return
    }
    // 如果开启送货上门最低金额设置且不满足最低金额 && 开启了上门自提
    if ((minConfig.minDeliverGoodsStatus === 1 && totalMoney < minConfig.minDeliverGoodsMoney) && pickupConfig.pickupStatus === '1') {
      distributionWay = 2
    }
    const data = {
      companyId:this.companyId,
      distributionWay: 1,
      storeList: []
    }
    data.storeList = [
      {
        storeId: this.detailInfo.storeId,
        storeName: this.storeInfo.companyName,
        storeLogo: this.storeInfo.logoUrl,
        sendConfig: sendTimeConfig,
        pickupConfig: pickupConfig,
        pickupTimeConfig: pickupTimeConfig,
        distributionWay: distributionWay,
        goodsPackageList: [
          {
            goodsId: this.detailInfo.goodsId,
            packageId: params.packageId || this.packageList[this.activeIndex].packageId,
            orderQuantity: params.orderQuantity || this.orderQuantity
          }
        ]
      }
    ]
    /* 存储获取预提交订单信息入参数据 */
    this.setPreOrderParams(data)
    this.$router.push('/submitMallOrder')
  }

  /**
   * 打开选择规格弹窗
   * @param type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单
   * 新增packageList：第一次弹框初始化数据，解决商品存在多规格，
   * 且仅有一个套餐的情况下，加入购物车、立即下单弹窗界面应默认选中该套餐问题
   */
  async showRules(type = '3') {
    // 单规格不打开加入规格弹框，加入购物车，下单操作直接处理
    let isMulti = !this.detailInfo.isMultiSpec
    if (isMulti) {
      // console.log('单规格');
      if(type === '1') {
        this.batchAddStoreShoppingCart()
      }
      // if(type === '2') {
      //   this.placeOrder()
      // }
    } else {
      ;(this.$refs.packageSelector as any).show({
        ruleType: type,
        detailInfo: this.detailInfo,
        selectList: this.selectValueList,
        defaultInfo: this.defaultDetailInfo,
        packageList: this.packageList
      })
    }
  }

  /* 去购物车 */
  toBuyCar() {
    this.$router.push({
      path: '/buyMallCar'
    })
  }
  /* 店铺 */
  toShopInfo() {
    this.$router.push({
      path: '/shopMallInfo',
      query: {
        storeId: this.storeInfo.companyId
      }
    })
  }

  reloadInfo() {
    this.getInfo()
    this.getPackageList()
    this.selectValueList = []
  }
}
